import { httpClient, ApiResponse } from '@/utils';
import { IContentBlockSchemasResponse } from '@/models/content-block-schema.model';

class ContentBlockSchemasAPI {
  static getSchemas(): ApiResponse<IContentBlockSchemasResponse> {
    return httpClient.get<IContentBlockSchemasResponse>('/content-block-schemas');
  }
}

export default ContentBlockSchemasAPI;
